import React from "react";
import Slider from "react-slick";
import Test_01 from '../../../assets/images/testimonial/testimonial-1.png';
import Test_02 from '../../../assets/images/svg/cote.svg';

const Testimonialone = () => {
    return (
        <div className="testimonial-section-one">
            <div className="container">
                <div className="heading-box text-center">
                    <span className="sub-title">our client say</span>
                </div>
                <div className="row">
                    <div className="col-lg-8 m-auto">
                        <Slider className="testimonial-slider-one">
                            <div className="testimonial-item-one">
                                <div className="testimonial-author-image">
                                    <img
                                        src={Test_01}
                                        alt="author-image"
                                    />
                                </div>
                                <h5>
                                    Vulputate mi sit amet mauris commodo quis imperdiet. Metus
                                    vulputate eu felis imperdiet proin nulla aliquet enim.
                                </h5>
                                <img src={Test_02} alt="icon" />
                                <p>John Doue , Digital marketing</p>
                            </div>
                            <div className="testimonial-item-one">
                                <div className="testimonial-author-image">
                                    <img
                                        src={Test_01}
                                        alt="author-image"
                                    />
                                </div>
                                <h5>
                                    Vulputate mi sit amet mauris commodo quis imperdiet. Metus
                                    vulputate eu felis imperdiet proin nulla aliquet enim.
                                </h5>
                                <img src={Test_02} alt="icon" />
                                <p>John Doue , Digital marketing</p>
                            </div>
                            <div className="testimonial-item-one">
                                <div className="testimonial-author-image">
                                    <img
                                        src={Test_01}
                                        alt="author-image"
                                    />
                                </div>
                                <h5>
                                    Vulputate mi sit amet mauris commodo quis imperdiet. Metus
                                    vulputate eu felis imperdiet proin nulla aliquet enim.
                                </h5>
                                <img src={Test_02} alt="icon" />
                                <p>John Doue , Digital marketing</p>
                            </div>
                            <div className="testimonial-item-one">
                                <div className="testimonial-author-image">
                                    <img
                                        src={Test_01}
                                        alt="author-image"
                                    />
                                </div>
                                <h5>
                                    Vulputate mi sit amet mauris commodo quis imperdiet. Metus
                                    vulputate eu felis imperdiet proin nulla aliquet enim.
                                </h5>
                                <img src={Test_02} alt="icon" />
                                <p>John Doue , Digital marketing</p>
                            </div>
                        </Slider>
                    </div>
                </div>
            </div>
        </div>

    )
}
export default Testimonialone; 